import { render, staticRenderFns } from "./btns.vue?vue&type=template&id=f6747b98&scoped=true"
import script from "./btns.vue?vue&type=script&lang=ts"
export * from "./btns.vue?vue&type=script&lang=ts"
import style0 from "./btns.vue?vue&type=style&index=0&id=f6747b98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6747b98",
  null
  
)

export default component.exports